<div class="min-h-screen bg-cloud-mist font-sans flex flex-col">

  <main>
    <div class="tfr-page-shell-narrow py-10 sm:py-14 lg:py-16">
      <a routerLink="/" class="mb-8 inline-flex text-[13px] font-medium text-slate-blue transition-colors hover:text-midnight-indigo">
        ← Volver al inicio
      </a>

      <div class="mb-12">
        <span class="inline-flex items-center px-3 py-1 rounded-[50px] text-xs font-semibold tracking-wide
                     bg-pale-gray text-glacier-blue mb-5">Legal</span>
        <h1 class="text-[38px] font-bold leading-[1.21] text-midnight-indigo mb-3">Derecho de desistimiento</h1>
        <p class="text-[14px] text-steel-gray">Última actualización: {{ updated }}</p>
      </div>

      @if (success()) {
        <div class="rounded-2xl border border-emerald-200 bg-emerald-50 px-6 py-5 text-[15px] leading-relaxed text-emerald-900">
          <p class="font-semibold text-midnight-indigo mb-2">Solicitud recibida</p>
          <p>
            Hemos registrado tu solicitud de desistimiento. Nuestro equipo la revisará y te contactará
            por correo electrónico con la resolución.
          </p>
        </div>
      } @else {
        <div class="space-y-8 text-[15px] leading-[1.71] text-slate-blue">
          <section>
            <p>
              Si deseas ejercer tu derecho de desistimiento sobre una reserva confirmada, completa el
              formulario con los datos de la reserva. La solicitud quedará registrada para revisión;
              no implica la cancelación automática de la reserva ni el reembolso inmediato.
            </p>
            <p class="mt-3">
              Solo pueden tramitarse reservas en estado <strong class="text-midnight-indigo">confirmado</strong>
              y dentro del plazo establecido en las condiciones del espacio.
            </p>
          </section>

          <form (submit)="$event.preventDefault(); submit()" class="space-y-5">
            <div>
              <label for="withdrawal-full-name" class="block text-[13px] font-semibold text-midnight-indigo mb-1.5">
                Nombre completo
              </label>
              <input id="withdrawal-full-name"
                     type="text"
                     autocomplete="name"
                     [value]="fullName()"
                     (input)="onFullNameInput($event)"
                     class="w-full rounded-xl border border-pale-gray bg-white px-4 py-3 text-[14px] text-midnight-indigo
                            placeholder:text-steel-gray focus:outline-none focus:ring-2 focus:ring-action-blue/30" />
            </div>

            <div>
              <label for="withdrawal-email" class="block text-[13px] font-semibold text-midnight-indigo mb-1.5">
                Correo electrónico de la reserva
              </label>
              <input id="withdrawal-email"
                     type="email"
                     autocomplete="email"
                     [value]="email()"
                     (input)="onEmailInput($event)"
                     class="w-full rounded-xl border border-pale-gray bg-white px-4 py-3 text-[14px] text-midnight-indigo
                            placeholder:text-steel-gray focus:outline-none focus:ring-2 focus:ring-action-blue/30" />
            </div>

            <div>
              <label for="withdrawal-booking-id" class="block text-[13px] font-semibold text-midnight-indigo mb-1.5">
                Identificador de reserva
              </label>
              <input id="withdrawal-booking-id"
                     type="text"
                     [value]="bookingId()"
                     (input)="onBookingIdInput($event)"
                     placeholder="Ej. abc123def456"
                     class="w-full rounded-xl border border-pale-gray bg-white px-4 py-3 text-[14px] text-midnight-indigo
                            placeholder:text-steel-gray focus:outline-none focus:ring-2 focus:ring-action-blue/30" />
              <p class="mt-1.5 text-[12px] text-steel-gray">
                Lo encontrarás en el correo de confirmación o en la sección Mis reservas.
              </p>
            </div>

            @if (error(); as err) {
              <p class="text-[13px] text-red-600">{{ err }}</p>
            }

            <p class="text-[12px] text-steel-gray">
              Al enviar este formulario aceptas el tratamiento de tus datos según nuestra
              <a routerLink="/privacidad" class="text-action-blue hover:underline">Política de Privacidad</a>.
            </p>

            <button type="submit"
                    [disabled]="!canSubmit()"
                    class="inline-flex items-center justify-center rounded-xl px-5 py-3 text-[14px] font-semibold text-white
                           bg-action-blue hover:brightness-110 disabled:opacity-40 disabled:cursor-not-allowed">
              @if (loading()) {
                Enviando&hellip;
              } @else {
                Enviar solicitud
              }
            </button>
          </form>
        </div>
      }

      <div class="mt-14 pt-8 border-t border-pale-gray">
        <a routerLink="/"
           class="inline-flex items-center gap-2 text-[13px] font-medium text-slate-blue
                  hover:text-midnight-indigo transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"/>
          </svg>
          Volver al inicio
        </a>
      </div>

    </div>
  </main>

  <app-site-footer />

</div>
